import './App.css';

import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'

import { BrowserRouter, Routes, Route } from "react-router";

import Home from './pages/Home.jsx';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
// import Contacto from './pages/Contacto.jsx';
import Legal from './pages/Legal.jsx';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        
        <Route path="/" element={<Home />} />
        {/* <Route path="/contacto" element={<Contacto />} /> */}
        <Route path="/legal" element={<Legal />} />

        {/* 404 / default */}
        <Route path="*" element={<Home />} />
        
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
